import { FeatureFlag } from '../FeatureFlag';

/**
 * Renders the shared SearchAlpha, Screener, and Scanner results area through the new owned grid
 * (`TableModelViewer`, ADR 0014) instead of the ag-grid `ColumnTemplateTableViewer`.
 *
 * This is separate from the Results-widget rollout so the Search family can be enabled or rolled
 * back independently.
 */
export const enableNewSearchGrid = new FeatureFlag({
    key: 'enable-new-search-grid',
    defaultValue: false,
});
